import classNames from 'classnames'
import React, { useEffect, useRef } from 'react'
import UpdatedTooltip from 'src/components/ui/UpdatedTooltip'

interface IBusyTimesBarGraphProps {
  data: number[] // should be 24 numbers representing each hour
  currentHour?: number // optional override for current hour (0-23)
}

const BusyTimesBarGraph: React.FC<IBusyTimesBarGraphProps> = ({ data, currentHour = new Date().getHours() }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const currentHourRef = useRef<HTMLDivElement>(null)
  const maxVal = data.length > 0 ? Math.max(...data) : 0

  useEffect(() => {
    if (currentHourRef.current && containerRef.current) {
      currentHourRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      })
    }
  }, [currentHour])

  const formatHour = (hour: number): string => {
    return hour === 0 ? '12AM' : hour < 12 ? `${hour}AM` : hour === 12 ? '12PM' : `${hour - 12}PM`
  }

  return (
    <div ref={containerRef} className='flex items-end justify-between h100 w100 px1'>
      {data.map((val, hour) => {
        const heightPercent = maxVal > 0 ? (val / maxVal) * 100 : 0
        const isCurrent = hour === currentHour

        return (
          <UpdatedTooltip
            text={`${val} trip(s)`}
            fullHeight={true}
            key={hour}
            aria-label={`${val} trips at ${formatHour(hour)}`}
          >
            <div ref={isCurrent ? currentHourRef : null} className='busy-times-bar-graph'>
              <div
                className={classNames('w100', isCurrent ? 'current-hour-indicator' : 'bar-graph')}
                style={{
                  height: `100%`
                }}
              >
                <div
                  className={classNames('bar-graph-blue w100')}
                  style={{ height: `${heightPercent}%` }} // Simulated fill within container
                />
              </div>
              <span className='h6 mt1 font-black'>{formatHour(hour)}</span>
            </div>
          </UpdatedTooltip>
        )
      })}
    </div>
  )
}

export default BusyTimesBarGraph



// WEBPACK FOOTER //
// ./src/components/trips/timeline-view/BusyTimesBarGraph.tsx